export default [
    {
        path: '/compte',
        name: 'account_login',
        component: () => import('/src/pages/PageAccountLogin.vue'),
    },
    {
        path: '/compte/client',
        name: 'client',
        component: () => import('/src/pages/clients/PageClient.vue'),
    },
    {
        path: '/compte/profil',
        name: 'client_profile',
        component: () => import('/src/pages/clients/PageClientProfile.vue'),
    },
    {
        path: '/compte/creation-mot-de-passe',
        name: 'client_password',
        component: () => import('/src/pages/clients/PageClientPassword.vue'),
    },
    {
        path: '/compte/reinitialiser-mot-de-passe',
        name: 'client_password_reset',
        component: () => import('/src/pages/clients/PageClientPassword.vue'),
    },
    {
        path: '/compte/mot-de-passe-oublie',
        name: 'client_forgot_password',
        component: () => import('/src/pages/clients/PageClientForgotPassword.vue'),
    },
    {
        path: '/compte/formulaire/individuel/:id',
        name: 'client_form_individuel',
        component: () => import('/src/pages/clients/PageClientFormIndividual.vue'),
    },
    {
        path: '/compte/formulaire/enfant/:id',
        name: 'client_form_enfant',
        component: () => import('/src/pages/clients/PageClientFormChild.vue'),
    },
    {
        path: '/compte/formulaire/adolescent/:id',
        name: 'client_form_adolescent',
        component: () => import('/src/pages/clients/PageClientFormAdolescent.vue'),
    },
    {
        path: '/compte/formulaire/deuil-deces/:id',
        name: 'client_form_deuil',
        component: () => import('/src/pages/clients/PageClientFormMourning.vue'),
    },
    {
        path: '/compte/formulaire/coaching-parents-educateurs/:id',
        name: 'client_form_coaching',
        component: () => import('/src/pages/clients/PageClientFormCoaching.vue'),
    },
    {
        path: '/compte/formulaire/couple-dyade/:id',
        name: 'client_form_couple',
        component: () => import('/src/pages/clients/PageClientFormCouple.vue'),
    },
    {
        path: '/compte/annuler-jumelage/:id',
        name: 'client_cancel_matching',
        component: () => import('/src/pages/clients/PageClientCancelMatching.vue'),
    },
];
